import { Fragment, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setFormValue, setPageValue } from "../../redux/slices/alertspageslice";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { RadioButton, Checkbox } from "@progress/kendo-react-inputs";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { Icon, useRtl } from "@progress/kendo-react-common";
import {
  FormInput,
  FormDropDownList,
  FormTextArea,
  FormDropDownListById,
  FormComboBoxById,
  FormCheckbox,
  FormHidden,
} from "../../forms/form-components";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { CollapsableFormRegion } from "../../components/collapsableformregion";
import { formValidator } from "./alertspageformvalidator";
import { List } from "../../components/list";
import { AggregateFunction } from "../../lib/aggregatefunctions";

//query builder
import { formatQuery, QueryBuilder, ValueEditor } from "react-querybuilder";
import { QueryValueEditor } from "../../components/querybuilder/queryvalueeditor";
import { getQueryOperators } from "../../components/querybuilder/queryoperators";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
//import 'react-querybuilder/dist/query-builder.css';

// const groupByItemRenderer = (currentTheme, onGroupedFieldCheck) => (props, item, index) => {
//     return (
//       <div key={item.Id} className={`list-item`}>
//         <div style={{width:28}}>
//             <Checkbox value={item.Checked} onChange={e => onGroupedFieldCheck(item)} />
//         </div>
//         <div className="list-item-title">{item.Title}</div>
//     </div>
//     );
// };

// const userItemRenderer = (currentTheme, onUserCheck) => (props, item, index) => {
//     return (
//       <div key={item.Id} className={`list-item`}>
//         <div style={{width:28}}>
//             <Checkbox value={item.Checked} onChange={e => onUserCheck(item)} />
//             </div>
//         <div className="list-item-title">{item.Name}</div>
//     </div>
//     );
// };

export const AlertsPageForm = (props) => {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.alertsPage);
  const currentDataset = pageState.currentDataset;
  const { t } = useTranslation();

  let aggregateExpressions = currentDataset.Lookups.AggregateExpressions;
  let fields = currentDataset.Lookups.Fields;
  let comparisonOperators = currentDataset.Lookups.Operators;
  let alertRecurrsEveryIntervals =
    currentDataset.Lookups.AlertRecurrsEveryIntervals;
  let alertCoveredPeriodIntervals =
    currentDataset.Lookups.AlertCoveredPeriodIntervals;
  let alertVariantCoveredPeriodIntervals =
    currentDataset.Lookups.AlertVariantCoveredPeriodIntervals;
  let alertImportances = currentDataset.Lookups.AlertImportances;

  let aggregateFunctions = currentDataset.Lookups.AggregateFunctions;
  let timeFields = currentDataset.Lookups.TimeFields;
  let users = pageState.formValues.Viewers;
  let groups = pageState.formValues.Groups;
  let groupByFields = pageState.formValues.GroupedFields;

  let fieldId = pageState.formValues.FieldId;
  let aggregateFunctionId = pageState.formValues.AggregateFunctionId;
  let aggregateFunction =
    aggregateFunctionId == 0
      ? null
      : AggregateFunction.getById(aggregateFunctionId);

  fields = fields.filter((e) => {
    if (aggregateFunction == null) return e.Id == null;
    else
      return (
        e.Id == null ||
        aggregateFunction.getReturnTypeFromField(e.DataTypeId) == 2
      );
  });

  const getOperators = (fieldName) => {
    let field = currentDataset.Where[fieldName];
    if (!field) return [];

    return getQueryOperators(field.DataTypeId, field.IsLookup);
  };

  let isGrouped = groupByFields.find((e) => e.Checked == true);

  let userIsNotified = users.find((e) => e.Checked == true);

  //handle is dirty
  const updateDirtyState = props.updateDirtyState;

  useEffect(() => {
    updateDirtyState();
  }, [pageState.formInitialValues, pageState.formValues]);

  return (
    <Fragment>
      <Form
        validator={formValidator}
        key={pageState.formKey}
        initialValues={{ ...pageState.formInitialValues }}
        render={(formRenderProps) => {
          return (
            <FormElement
              horizontal={false}
              style={
                {
                  // width: 250,
                }
              }
            >
              <CollapsableFormRegion
                className="form-region-main"
                title={t("alerts.general")}
                open={pageState.formValues.generalOpen}
                onToggle={(e) =>
                  dispatch(
                    setFormValue({
                      id: "generalOpen",
                      value: !pageState.formValues.generalOpen,
                    }),
                  )
                }
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <Field
                      autoFocus={true}
                      id={"Title"}
                      name={"Title"}
                      label={t("alerts.title")}
                      component={FormInput}
                      onChange={(e) =>
                        dispatch(setFormValue({ id: "Title", value: e.value }))
                      }
                      disabled={
                        pageState.isProcessing || pageState.formValues.IsSystem
                      }
                      style={{ width: "100%" }}
                      maxLength={50}
                    />
                  </div>
                  <div style={{ marginLeft: 18 }}>
                    <Field
                      id={"IsActive"}
                      name="IsActive"
                      label={t("alerts.active")}
                      component={FormCheckbox}
                      onChange={(e) =>
                        dispatch(
                          setFormValue({
                            id: "IsActive",
                            value: e.target.value,
                          }),
                        )
                      }
                      disabled={
                        pageState.isProcessing || pageState.formValues.IsSystem
                      }
                    />
                  </div>
                </div>
                <div style={{ marginTop: 26 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <Field
                        id={"Importance"}
                        name={"Importance"}
                        component={FormDropDownListById}
                        data={alertImportances}
                        dataItemKey="Id"
                        textField="Title"
                        onChange={(e) =>
                          dispatch(
                            setFormValue({ id: "Importance", value: e.value }),
                          )
                        }
                        disabled={
                          pageState.processing || pageState.formValues.IsSystem
                        }
                        style={{
                          color:
                            pageState.formValues.Importance >= 3
                              ? currentTheme.error
                              : undefined,
                          fontWeight:
                            pageState.formValues.Importance >= 5 ? 700 : 400,
                        }}
                        label={t("alerts.importance")}
                      />
                    </div>
                    <div className="separator" />

                    <div style={{ flex: 1 }}>
                      <Field
                        id={"Interpretation"}
                        name={"Interpretation"}
                        component={FormInput}
                        onChange={(e) =>
                          dispatch(
                            setFormValue({
                              id: "Interpretation",
                              value: e.value,
                            }),
                          )
                        }
                        disabled={
                          pageState.processing || pageState.formValues.IsSystem
                        }
                        style={{}}
                        label={t("alerts.interpretation")}
                        maxLength={1000}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <Field
                    id={"Description"}
                    name={"Description"}
                    label={t("alerts.desc")}
                    component={FormTextArea}
                    onChange={(e) =>
                      dispatch(
                        setFormValue({ id: "Description", value: e.value }),
                      )
                    }
                    disabled={
                      pageState.isProcessing || pageState.formValues.IsSystem
                    }
                    style={{ height: 50, width: "100%" }}
                    maxLength={255}
                  />
                </div>
              </CollapsableFormRegion>

              <CollapsableFormRegion
                className="form-region-misc"
                title={t("alerts.recurrence")}
                open={pageState.formValues.miscOpen}
                onToggle={(e) =>
                  dispatch(
                    setFormValue({
                      id: "miscOpen",
                      value: !pageState.formValues.miscOpen,
                    }),
                  )
                }
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    style={{
                      marginTop: 6,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <Field
                        id={"TimeFieldId"}
                        name={"TimeFieldId"}
                        component={FormDropDownListById}
                        data={timeFields}
                        dataItemKey="Id"
                        textField="Title"
                        onChange={(e) =>
                          dispatch(
                            setFormValue({ id: "TimeFieldId", value: e.value }),
                          )
                        }
                        disabled={
                          pageState.processing || pageState.formValues.IsSystem
                        }
                        style={{}}
                        label={t("alerts.time")}
                      />
                    </div>
                    <div className="separator"></div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <Field
                          id={"RecurrsEvery"}
                          name={"RecurrsEvery"}
                          component={FormDropDownListById}
                          data={alertRecurrsEveryIntervals}
                          dataItemKey="Id"
                          textField="Title"
                          onChange={(e) =>
                            dispatch(
                              setFormValue({
                                id: "RecurrsEvery",
                                value: e.value,
                              }),
                            )
                          }
                          disabled={
                            pageState.processing ||
                            pageState.formValues.IsSystem
                          }
                          style={{}}
                          label={t("alerts.recurs")}
                        />
                      </div>
                      <div className="separator"></div>
                      <div style={{ flex: 1 }}>
                        <Field
                          id={"CoveredPeriod"}
                          name={"CoveredPeriod"}
                          component={FormDropDownListById}
                          data={alertCoveredPeriodIntervals}
                          dataItemKey="Id"
                          textField="Title"
                          onChange={(e) =>
                            dispatch(
                              setFormValue({
                                id: "CoveredPeriod",
                                value: e.value,
                              }),
                            )
                          }
                          disabled={
                            pageState.processing ||
                            pageState.formValues.IsSystem
                          }
                          style={{}}
                          label={t("alerts.covered")}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="url"
                    style={{
                      marginTop: 22,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Field
                          id={"NotifyThroughApplication"}
                          name="NotifyThroughApplication"
                          label={t("alerts.notify1")}
                          component={FormCheckbox}
                          onChange={(e) => {
                            dispatch(
                              setFormValue({
                                id: "NotifyThroughApplication",
                                value: e.target.value,
                              }),
                            );
                          }}
                          disabled={
                            pageState.isProcessing ||
                            pageState.formValues.IsSystem
                          }
                          style={{}}
                        />
                      </div>
                      <div className="separator"></div>
                      <div
                        style={{
                          flex: 1,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Field
                          id={"NotifyThroughEmail"}
                          name="NotifyThroughEmail"
                          label={t("alerts.notify2")}
                          component={FormCheckbox}
                          onChange={(e) => {
                            dispatch(
                              setFormValue({
                                id: "NotifyThroughEmail",
                                value: e.target.value,
                              }),
                            );
                          }}
                          disabled={
                            pageState.isProcessing ||
                            pageState.formValues.IsSystem
                          }
                          style={{}}
                        />
                      </div>
                    </div>
                    <div className="separator" />
                    <div style={{ flex: 1 }}>
                      <Field
                        id={"Url"}
                        name={"Url"}
                        label={t("alerts.apiurl")}
                        component={FormInput}
                        onChange={(e) =>
                          dispatch(setFormValue({ id: "Url", value: e.value }))
                        }
                        disabled={
                          pageState.isProcessing ||
                          pageState.formValues.IsSystem
                        }
                        style={{ flex: 1, width: "100%" }}
                        maxLength={500}
                      />
                    </div>
                  </div>
                  <div
                    className=""
                    style={{
                      marginTop: 22,
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div style={{ marginBottom: 2 }}>
                        {t("alerts.notify3")}
                      </div>
                      <MultiSelect
                        data={users}
                        dataItemKey="Id"
                        textField="Name"
                        value={users.filter((e) => e.Checked == true)}
                        onChange={props.onUsersCheck}
                        style={{
                          width: "100%",
                        }}
                        placeholder={t("alerts.notify4")}
                      />
                    </div>
                    <div className="separator"></div>
                    <div
                      style={{
                        flex: 1,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div style={{ marginBottom: 2 }}>
                        {t("alerts.notify5")}
                      </div>
                      <MultiSelect
                        data={groups}
                        dataItemKey="Id"
                        textField="Name"
                        value={groups.filter((e) => e.Checked == true)}
                        onChange={props.onGroupsCheck}
                        style={{
                          width: "100%",
                        }}
                        placeholder={t("alerts.notify6")}
                      />
                    </div>
                  </div>
                </div>
              </CollapsableFormRegion>

              <CollapsableFormRegion
                className="form-region-expression"
                title={t("alerts.keymetric")}
                open={pageState.formValues.expressionOpen}
                onToggle={(e) =>
                  dispatch(
                    setFormValue({
                      id: "expressionOpen",
                      value: !pageState.formValues.expressionOpen,
                    }),
                  )
                }
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    style={{
                      marginTop: 6,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <RadioButton
                        name="groupValue"
                        value={true}
                        checked={true === pageState.formValues.IsAggregate}
                        label={t("alerts.agg_exp")}
                        disabled={
                          pageState.isProcessing ||
                          pageState.formValues.IsSystem
                        }
                        onChange={(e) => {
                          dispatch(
                            setFormValue({ id: "IsAggregate", value: e.value }),
                          );
                          dispatch(
                            setFormValue({
                              id: "AggregateExpressionId",
                              value: null,
                            }),
                          );
                          dispatch(
                            setFormValue({
                              id: "AggregateFunctionId",
                              value: 0,
                            }),
                          );
                          dispatch(
                            setFormValue({ id: "FieldId", value: null }),
                          );

                          formRenderProps.onChange("IsAggregate", {
                            value: e.value,
                          });
                          formRenderProps.onChange("AggregateExpressionId", {
                            value: null,
                          });
                          formRenderProps.onChange("AggregateFunctionId", {
                            value: 0,
                          });
                          formRenderProps.onChange("FieldId", { value: null });
                        }}
                      />
                      <Field
                        id={"AggregateExpressionId"}
                        name={"AggregateExpressionId"}
                        component={FormDropDownListById}
                        data={aggregateExpressions}
                        dataItemKey="Id"
                        textField="Title"
                        onChange={(e) =>
                          dispatch(
                            setFormValue({
                              id: "AggregateExpressionId",
                              value: e.value,
                            }),
                          )
                        }
                        disabled={
                          pageState.processing ||
                          pageState.formValues.IsSystem ||
                          !pageState.formValues.IsAggregate
                        }
                        style={{ width: "100%", marginTop: 5 }}
                      />
                    </div>
                    <div className="separator"></div>
                    <div style={{ flex: 1 }}>
                      <RadioButton
                        name="groupValue"
                        value={false}
                        checked={false === pageState.formValues.IsAggregate}
                        label={t("alerts.agg_fct")}
                        disabled={
                          pageState.isProcessing ||
                          pageState.formValues.IsSystem
                        }
                        onChange={(e) => {
                          dispatch(
                            setFormValue({ id: "IsAggregate", value: e.value }),
                          );
                          dispatch(
                            setFormValue({
                              id: "AggregateExpressionId",
                              value: null,
                            }),
                          );
                          dispatch(
                            setFormValue({
                              id: "AggregateFunctionId",
                              value: 0,
                            }),
                          );
                          dispatch(
                            setFormValue({ id: "FieldId", value: null }),
                          );

                          formRenderProps.onChange("IsAggregate", {
                            value: e.value,
                          });
                          formRenderProps.onChange("AggregateExpressionId", {
                            value: null,
                          });
                          formRenderProps.onChange("AggregateFunctionId", {
                            value: 0,
                          });
                          formRenderProps.onChange("FieldId", { value: null });
                        }}
                      />
                      <div
                        className="aggregate-function"
                        style={{
                          marginTop: 4,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                        }}
                      >
                        <Field
                          id={"AggregateFunctionId"}
                          name={"AggregateFunctionId"}
                          component={FormDropDownListById}
                          data={aggregateFunctions}
                          dataItemKey="Id"
                          textField="Title"
                          onChange={(e) => {
                            dispatch(
                              setFormValue({
                                id: "AggregateFunctionId",
                                value: e.value,
                              }),
                            );

                            dispatch(
                              setFormValue({ id: "FieldId", value: null }),
                            );
                            formRenderProps.onChange("FieldId", {
                              value: null,
                            });
                          }}
                          disabled={
                            pageState.processing ||
                            pageState.formValues.IsSystem ||
                            pageState.formValues.IsAggregate
                          }
                          style={{ width: 150 }}
                        />
                        <div className="separator"></div>
                        <Field
                          id={"FieldId"}
                          name={"FieldId"}
                          component={FormDropDownListById}
                          data={fields}
                          dataItemKey="Id"
                          textField="Title"
                          onChange={(e) =>
                            dispatch(
                              setFormValue({ id: "FieldId", value: e.value }),
                            )
                          }
                          disabled={
                            pageState.processing ||
                            pageState.formValues.IsSystem ||
                            pageState.formValues.IsAggregate
                          }
                          style={{ flex: 1 }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="operations"
                    style={{
                      marginTop: 22,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        flex: 1,
                      }}
                    >
                      <Field
                        id={"OperatorId"}
                        name={"OperatorId"}
                        component={FormDropDownListById}
                        data={comparisonOperators}
                        dataItemKey="Id"
                        textField="Title"
                        onChange={(e) => {
                          dispatch(
                            setFormValue({ id: "OperatorId", value: e.value }),
                          );
                          if (e.value != 7 && e.value != 8) {
                            dispatch(
                              setFormValue({
                                id: "TargetValueMax",
                                value: pageState.formValues.TargetValueMin,
                              }),
                            );
                          }
                          formRenderProps.onChange("TargetValueMax", {
                            value: pageState.formValues.TargetValueMin,
                          });
                        }}
                        disabled={
                          pageState.processing || pageState.formValues.IsSystem
                        }
                        style={{ width: 135, marginTop: 0 }}
                        label={t("alerts.operator")}
                      />
                      <div className="separator"></div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginLeft: 0,
                        }}
                      >
                        <div style={{ marginLeft: 0, flex: 1 }}>
                          <Field
                            id={"TargetValueMin"}
                            name={"TargetValueMin"}
                            component={FormInput}
                            onChange={(e) => {
                              dispatch(
                                setFormValue({
                                  id: "TargetValueMin",
                                  value: e.value,
                                }),
                              );
                              if (
                                pageState.formValues.OperatorId != 7 &&
                                pageState.formValues.OperatorId != 8
                              ) {
                                dispatch(
                                  setFormValue({
                                    id: "TargetValueMax",
                                    value: e.value,
                                  }),
                                );
                                formRenderProps.onChange("TargetValueMax", {
                                  value: e.value,
                                });
                              }
                            }}
                            disabled={
                              pageState.processing ||
                              pageState.formValues.IsSystem
                            }
                            style={{ flex: 1 }}
                            label={t("alerts.threshold")}
                            type="number"
                          />
                        </div>
                        {(pageState.formValues.OperatorId == 7 ||
                          pageState.formValues.OperatorId == 8) && (
                          <div style={{ marginLeft: 16, flex: 1 }}>
                            <Field
                              id={"TargetValueMax"}
                              name={"TargetValueMax"}
                              component={FormInput}
                              onChange={(e) =>
                                dispatch(
                                  setFormValue({
                                    id: "TargetValueMax",
                                    value: e.value,
                                  }),
                                )
                              }
                              disabled={
                                pageState.processing ||
                                pageState.formValues.IsSystem
                              }
                              style={{}}
                              label="&nbsp;"
                              type="number"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="separator"></div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        flex: 1,
                      }}
                    >
                      <div
                        style={{
                          paddingTop: 16,
                          alignSelf: "flex-start",
                          width: 150,
                        }}
                      >
                        <Field
                          id={"IsVariant"}
                          name="IsVariant"
                          label={t("alerts.variation")}
                          component={FormCheckbox}
                          onChange={(e) => {
                            dispatch(
                              setFormValue({
                                id: "IsVariant",
                                value: e.target.value,
                              }),
                            );

                            dispatch(
                              setFormValue({
                                id: "VariantCoveredPeriod",
                                value: 0,
                              }),
                            );
                            formRenderProps.onChange("VariantCoveredPeriod", {
                              value: 0,
                            });
                          }}
                          disabled={
                            pageState.isProcessing ||
                            pageState.formValues.IsSystem
                          }
                          style={{}}
                        />
                      </div>
                      {pageState.formValues.IsVariant && (
                        <Fragment>
                          <div className="separator" />
                          <div style={{ flex: 1 }}>
                            <Field
                              id={"VariantCoveredPeriod"}
                              name={"VariantCoveredPeriod"}
                              component={FormDropDownListById}
                              data={alertVariantCoveredPeriodIntervals}
                              dataItemKey="Id"
                              textField="Title"
                              onChange={(e) =>
                                dispatch(
                                  setFormValue({
                                    id: "VariantCoveredPeriod",
                                    value: e.value,
                                  }),
                                )
                              }
                              disabled={
                                pageState.processing ||
                                pageState.formValues.IsSystem
                              }
                              style={{}}
                              label={t("alerts.period")}
                            />
                          </div>
                        </Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </CollapsableFormRegion>

              <CollapsableFormRegion
                className="form-region-filter"
                title={t("alerts.filter1")}
                open={pageState.formValues.filterOpen}
                onToggle={(e) =>
                  dispatch(
                    setFormValue({
                      id: "filterOpen",
                      value: !pageState.formValues.filterOpen,
                    }),
                  )
                }
              >
                <QueryBuilder
                  query={pageState.formValues.WhereObject}
                  fields={pageState.currentDataset.Where}
                  getOperators={getOperators}
                  onQueryChange={(q) => {
                    dispatch(setFormValue({ id: "WhereObject", value: q }));
                  }}
                  controlElements={{
                    valueEditor: (editorProps) => (
                      <QueryValueEditor
                        {...editorProps}
                        handleSaveKey={props.onKeyChange}
                      />
                    ),
                  }}
                  showCloneButtons={true}
                />
              </CollapsableFormRegion>

              <CollapsableFormRegion
                className="form-region-group-by"
                title={t("alerts.group1")}
                open={pageState.formValues.groupByOpen}
                onToggle={(e) =>
                  dispatch(
                    setFormValue({
                      id: "groupByOpen",
                      value: !pageState.formValues.groupByOpen,
                    }),
                  )
                }
              >
                <MultiSelect
                  data={groupByFields}
                  dataItemKey="Id"
                  textField="Title"
                  value={groupByFields.filter((e) => e.Checked == true)}
                  onChange={props.onGroupedFieldsCheck}
                  style={{
                    width: "100%",
                    marginTop: 4,
                  }}
                  placeholder={t("alerts.field")}
                />
              </CollapsableFormRegion>
            </FormElement>
          );
        }}
      />
      <style>
        {`             
                    .alerts-page-form .separator
                    {
                        width: 20px;
                    }

                    .alerts-page-form .k-chip-list
                    {
                        padding: 6px;
                    }

                    .alerts-page-form .k-chip-list .k-chip
                    {
                        line-height: 1.25;
                        margin-right: 4px;
                    }

                    .alerts-page-form > .content
                    {
                        padding: 0px;
                        background-color: ${currentTheme.componentBg};
                        align-items: flex-start;
                    }

                    .alerts-page-form .k-form
                    {          
                        /*the kendo form which is child of my form.content*/              
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        justify-content: space-between;
                        padding: 0 12px 22px 16px;/*keep 12px in right and bottom so that when minimizing we keep a white region to the right and bottom; also keep 8px on the left*/
                        width: 1100px;
                    }

                    /* main region */
                    .alerts-page-form .form-region-main
                    {
                        margin-top: 8px!important;
                        border-radius: 4px;
                        padding: 8px 0px 0px 0px;
                    }

                    .alerts-page-form .form-region-main .header
                    {
                        padding: 4px;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                    }

                    .alerts-page-form .form-region-main .header .right-line
                    {
                        display: none;
                    }

                    .alerts-page-form .form-region-main .content
                    {
                        padding-left: 12px;
                    }

                    .alerts-page-form .form-region-main .form-region-root
                    {
                    }

                    .alerts-page-form .form-region-main > .form-region-root .content div:first-child div:first-child .k-form-field:nth-child(1)
                    {
                        /*title*/
                        /*let title NOT go down by 26px as other fields*/
                        margin-top: 6px!important;
                    }

                    .alerts-page-form .form-region-main > .form-region-root .content div:first-child div:first-child .k-form-field:nth-child(2)
                    {
                        /*isactive*/
                        margin-top: 10px!important;
                    }

                    .alerts-page-form .form-region-main > .form-region-root .content div:first-child div:nth-child(3) .k-form-field:first-child
                    {
                        /*description*/
                        margin-top: 6px;
                    }                    

                    /*misc*/
                    .alerts-page-form .form-region-misc
                    {
                        margin-top: 28px!important;
                        border-radius: 4px;
                        padding: 8px 0px 0px 0px;
                    }

                    .alerts-page-form .form-region-misc .header
                    {
                        padding: 4px;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                    }

                    .alerts-page-form .form-region-misc .header .right-line
                    {
                        display: none;
                    }

                    .alerts-page-form .form-region-misc .content
                    {
                        padding-left: 12px;
                        margin-top: 12px;
                    }

                    .alerts-page-form .form-region-misc .form-region-root
                    {
                    }

                    .alerts-page-form .form-region-misc .k-form-field
                    {
                        /*let title NOT go down by 26px as other fields*/
                        margin-top:0 !important;
                    }

                    .alerts-page-form .form-region-misc .url .k-form-field
                    {
                        flex:1;
                    }
                                    

                    /* expression region */
                    .alerts-page-form .form-region-expression
                    {
                        margin-top: 28px!important;
                        border-radius: 4px;
                        padding: 8px 0px 0px 0px;
                    }

                    .alerts-page-form .form-region-expression .header
                    {
                        padding: 4px;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                    }

                    .alerts-page-form .form-region-expression .header .right-line
                    {
                        display: none;
                    }

                    .alerts-page-form .form-region-expression .content
                    {
                        padding-left: 12px;
                        margin-top: 12px;
                    }

                    .alerts-page-form .form-region-expression .form-region-root
                    {
                    }

                    .alerts-page-form .form-region-expression .k-form-field
                    {
                        /*let title NOT go down by 26px as other fields*/
                        margin-top:0 !important;
                    }

                    .alerts-page-form .form-region-expression .aggregate-function .k-form-field:nth-child(3),
                    .alerts-page-form .form-region-expression .interpretation .k-form-field
                    {
                        flex: 1;
                        width: 100%;
                    }
                    

                    /*group by section*/
                    .alerts-page-form .form-region-group-by
                    {
                        margin-top: 36px!important;
                        border-radius: 4px;*/
                        padding: 8px 0px 8px 0px;
                    }

                    .alerts-page-form .form-region-group-by .header
                    {
                        padding: 4px;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                    }

                  
                    /*filter section*/
                    .alerts-page-form .form-region-filter
                    {
                        margin-top: 36px!important;
                        border-radius: 4px;*/
                        padding: 8px 0px 8px 0px;
                    }

                    .alerts-page-form .form-region-filter .header
                    {
                        padding: 4px;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                    }

                    .alerts-page-form .form-region-filter .header .right-line
                    {
                        display: none;
                    }

                    .alerts-page-form .form-region-filter .content
                    {
                        padding-left: 12px;
                        margin-top: 12px;
                    }
                    
                    .alerts-page-form .form-region-filter .form-region-root
                    {
                    }       
                    

                    /*query builder*/
                    .alerts-page-form .form-region-filter .ruleGroup, .alerts-page-form .form-region-filter .ruleGroup-combinators,
                    .alerts-page-form .form-region-filter .ruleGroup-addRule, .alerts-page-form .form-region-filter .ruleGroup-addGroup,
                    .alerts-page-form .form-region-filter .rule-remove, .alerts-page-form .form-region-filter .ruleGroup-remove,
                    .alerts-page-form .form-region-filter .rule-fields, .alerts-page-form .form-region-filter .rule-operators,
                    .alerts-page-form .form-region-filter .rule-value, .alerts-page-form .form-region-filter .rule-cloneRule
                    {
                        border-color: ${currentTheme.componentBorderColor};
                        background-color: ${currentTheme.componentBg};
                        color: ${currentTheme.componentText};                                               
                    }

                    .alerts-page-form .form-region-filter .rule-fields:focus, .alerts-page-form .form-region-filter .rule-operators:focus,
                    .alerts-page-form .form-region-filter .rule-value:focus
                    {
                        outline: none
                    }    
                    
                    .alerts-page .form-region-filter .rule-remove, .alerts-page .form-region-filter .ruleGroup-remove
                    {
                        color: ${currentTheme.error};
                        padding: 8px 10px 7px 10px;
                    }

                    @media (max-width: 1024px)
                    {
                        .alerts-page-form .k-form
                        {
                            width: 100%;
                            padding: 0 16px 16px;
                            overflow-x: hidden;
                            box-sizing: border-box;
                        }

                        .alerts-page-form .separator
                        {
                            display: none;
                        }

                        .alerts-page-form .form-region-main .content,
                        .alerts-page-form .form-region-misc .content,
                        .alerts-page-form .form-region-expression .content,
                        .alerts-page-form .form-region-filter .content
                        {
                            padding-left: 0;
                            padding-right: 0;
                        }

                        .alerts-page-form .form-region-main .content > div:first-child,
                        .alerts-page-form .form-region-main .content > div:nth-child(2) > div,
                        .alerts-page-form .form-region-misc .content > div > div,
                        .alerts-page-form .form-region-expression .content > div > div,
                        .alerts-page-form .form-region-expression .aggregate-function,
                        .alerts-page-form .form-region-expression .operations
                        {
                            flex-direction: column !important;
                            gap: 12px;
                        }

                        .alerts-page-form .form-region-main .content > div:first-child > div,
                        .alerts-page-form .form-region-main .content > div:nth-child(2) > div > div,
                        .alerts-page-form .form-region-misc .content > div > div > div,
                        .alerts-page-form .form-region-expression .content > div > div > div
                        {
                            width: 100%;
                        }
                    }
                `}
      </style>
    </Fragment>
  );
};
